const { RX } = require('../../RX/RX')

/**
 * Megmondja, hogy egy adott string tartalmaz-e html tageket.
 * @param {string} str - A string, amit vizsgálunk.
 * @returns {boolean} Tartalmaz HTML tageket?
 */
module.exports.isContainsHtmlTag = function isContainsHtmlTag (str) {
  // eslint-disable-next-line regexp/no-dupe-disjunctions -- Meh?
  return RX.test(/<(.*)>.*?|<(.*) \/>/, str)
}
